/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const PanelBottomOpen = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
    ["line", { x1: "3", x2: "21", y1: "15", y2: "15" }],
    ["path", { d: "m9 10 3-3 3 3" }]
  ]
];

export { PanelBottomOpen as default };
//# sourceMappingURL=panel-bottom-open.js.map
